
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/unacademy-one-kota-terms",
      function () {
        return require("private-next-pages/unacademy-one-kota-terms.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/unacademy-one-kota-terms"])
      });
    }
  